import _extends from "@babel/runtime/helpers/extends";
import classnames from "classnames/dedupe";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";
export const Toast = /*#__PURE__*/React.forwardRef(
/**
 *
 * @param {object} props
 * @param {any} [props.children]
 * @param {any} [props.className]
 * @param {any} [props.title]
 * @param {() => any} [props.onClose]
 * @param {number} [props.duration]
 * @param {"top-left" | "top-right" | "bottom-left" | "bottom-right"} [props.location]
 * @param {boolean} [props.isVisible]
 * @param {*} ref
 * @returns {JSX.Element}
 */
function Toast({
  children,
  className,
  title,
  onClose,
  duration = 10000,
  location = "top-right",
  isVisible,
  ...props
}, ref) {
  useEffect(() => {
    if (isVisible && duration > 0) {
      console.log("here");
      setTimeout(onClose, duration);
    }
  }, [isVisible]);
  const toastClasses = classnames(["rounded z-20 absolute max-w-lg p-2 shadow-lg"], location === "top-left" && "top-0 left-0 mt-4 ml-4", location === "top-right" && "top-0 right-0 mt-4 mr-4", location === "bottom-left" && "bottom-0 left-0 mb-4 ml-4", location === "bottom-right" && "bottom-0 right-0 mb-4 mr-4", !isVisible && "opacity-0 pointer-events-none", className);
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    className: toastClasses,
    ref: ref
  }), /*#__PURE__*/React.createElement("div", {
    className: `flex ${title ? "justify-between" : "justify-end"}`
  }, title, /*#__PURE__*/React.createElement(FaTimes, {
    className: "text-gray-600 text-xl font-extralight cursor-pointer",
    onClick: onClose
  })), children);
});
Toast.propTypes = {
  className: PropTypes.any,
  children: PropTypes.any,
  title: PropTypes.any,
  onClose: PropTypes.func,
  duration: PropTypes.number,
  // @ts-ignore
  location: PropTypes.oneOf(["top-left", "top-right", "bottom-left", "bottom-right"]),
  isVisible: PropTypes.bool
};